/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassPlanningSharedQueryViewModel } from "../types/ClassPlanningSharedQueryViewModel.ts";

export const classPlanningSharedQueryViewModelSchema = z.object({
  search: z.string().nullish(),
  take: z.optional(z.number().int()),
  culture: z.string().nullish(),
  courseId: z.number().int().nullish(),
}) as unknown as ToZod<ClassPlanningSharedQueryViewModel>;
